<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Настройки</strong>
                </CCardHeader>

                <CCardBody>
                    <StatusDialogTabLinks />
                    <CRow class="mt-3"> 
                        <CCol
                            tag="label"
                            class="col-form-label">
                            Показывать статусы в приложении
                        </CCol>
                        <CCol>
                            <CSwitch
                                class=""
                                color="success"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="dialogs.enabled" />
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import StatusDialogTabLinks from '@/components/StatusDialogsTabLinks'

    export default {
        name: 'StatusDialogSettings',
        components: {
            StatusDialogTabLinks
        },

        data: () => ({
            dialogs: {
                type: '',
                enabled: false,
            }
        }),

        computed: {
        },

        async mounted() {
            const serviceType = this?.$route?.fullPath?.split('/')[2].replace(/s$/g, '');
            const { data } = await this.axios.get('/status-dialogs/settings/' + serviceType);
            if (data.id) {
                this.dialogs = data;
            }
        },

        methods: {
            async save () {
                try {
                    this.dialogs.type = this?.$route?.fullPath?.split('/')[2].replace(/s$/g, '');
                    await this.axios.post('/status-dialogs/settings/' + this.dialogs.type, this.dialogs);
                    this.goBack();
                } catch (e) {
                    console.log(e);
                }
            },
            goBack() {
                this.$router.go(-1);
            },
        }
    }
</script>
